export default "__VITE_ASSET__CdwB6Id8__"